import React from 'react'
import { Box, ListItemField, ListItemType, TextWithPointer, Tip } from '@common-fe/common-fe';

interface FieldProps {
  field: ListItemField;
}

const TerminationPlanListItemField: React.FC<FieldProps> = ({
  field,
}) => {
  if (field.type === ListItemType.Node) {
    return (
      <Box
        data-testid="TerminationPlanListItemField_container"
        background="canvas"
        justify="center"
        style={field.fieldStyle || { flex: field.flex || 1 }}
        height={{ min: '40px' }}
      >
        {field.node}
      </Box>
    )
  }
  return (
    <Box
      data-testid="TerminationPlanListItemField_container"
      background="canvas"
      justify="center"
      style={field.fieldStyle || { flex: field.flex || 1 }}
      height={{ min: '40px' }}
    >
      <>
        {field?.hasTip ? (
          <Tip
            plain
            content={(
              <Box elevation="default" background="canvas" pad="small">
                {field?.value}
              </Box>
            )}
          >
            <TextWithPointer
              style={field?.style}
              ellipsisMode={field?.ellipsisMode}
              title={field?.ellipsisMode ? field?.title : ''}
              size="medium"
              margin={{ right: 'spacing24' }}
              wordBreak="break-word"
              className={field?.hover ? 'hover-field' : ''}
            >
              {field?.title}
            </TextWithPointer>
          </Tip>
        ) : (
          <TextWithPointer
            style={field?.style}
            ellipsisMode={field?.ellipsisMode}
            title={field?.ellipsisMode ? field?.title : ''}
            size="medium"
            margin={{ right: 'spacing24' }}
            wordBreak="break-word"
          >
            {field?.title}
          </TextWithPointer>
        )}
      </>
    </Box>
  )
}

interface Props {
  fields?: ListItemField[];
  id?: string;
  editMode?: boolean;
}

export const TerminationPlanListItem: React.FC<Props> = ({
  fields = [],
  id,
  editMode = false,
}) => {
  return (
    <Box
      key={id}
      data-testid="TerminationPlanListItem_container"
      background="canvas"
      direction="row"
      height={{ min: '40px' }}
      align="start"
      pad={{ horizontal: 'spacing12', top: editMode ? 'spacing8' : undefined }}
      margin={{ top: editMode ? undefined : 'spacing2' }}
    >
      {fields.map((field) => (
        <TerminationPlanListItemField
          key={field.key}
          field={field}
        />  
      ))}

    </Box>
  )
}
